<script lang="ts">
  import { faXmark } from '@itdev-fortawesome/pro-regular-svg-icons/faXmark';
  import { faCheck } from '@itdev-fortawesome/pro-solid-svg-icons/faCheck';
  import { FontAwesomeIcon } from '@fortawesome/svelte-fontawesome';

  interface Props {
    onclick?: () => void;
    name: string;
    pointsValue: number;
    withIcon?: boolean;
    isComplete?: boolean;
  }

  let { onclick, name, pointsValue, withIcon = false, isComplete = false }: Props = $props();
</script>

{#if onclick === undefined}
  <li class="skill-item">
    {@render contents()}
  </li>
{:else}
  <button class="btn skill-item" type="button" {onclick}>
    {@render contents()}
  </button>
{/if}

{#snippet contents()}
  {#if withIcon}
    <span class="completion-icon">
      {#if isComplete}
        <FontAwesomeIcon icon={faCheck} />
      {:else}
        <FontAwesomeIcon icon={faXmark} class="text-tertiary" />
      {/if}
    </span>
  {/if}
  <span class="skill-name">{name}</span>
  <span class="points-value">{pointsValue} pt{pointsValue === 1 ? '' : 's'}</span>
{/snippet}

<style>
  .skill-item {
    display: flex;
    align-items: center;
    gap: 0.5em;
  }

  button.skill-item {
    width: calc(100% + 1rem); /* adding width to account for negative margin that 100% doesn't consider */
    padding: 0.125rem 0.5rem;
    margin: 0rem -0.5rem;
    --bs-btn-hover-bg: var(--bs-secondary-bg);
  }

  li.skill-item {
    list-style: none;
  }

  .skill-name {
    flex: 1;
    text-align: start;
  }

  .points-value {
    white-space: nowrap;
  }

  .completion-icon {
    flex-shrink: 0;
  }
</style>
